import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@achra/ui/skeleton';
function DescriptionSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex w-full flex-col gap-2"><Skeleton className="h-4.5 w-[90%]" /><Skeleton className="h-4.5 w-[70%]" /><Skeleton className="h-4.5 w-full" /><Skeleton className="h-4.5 w-[95%]" /><Skeleton className="h-4.5 w-[85%]" /><Skeleton className="h-4.5 w-[87%]" /><Skeleton className="h-4.5 w-[96%]" /><Skeleton className="h-4.5 w-[80%]" /><Skeleton className="h-4.5 w-[90%]" /><Skeleton className="h-4.5 w-full" /><Skeleton className="h-4.5 w-[20%]" /><Skeleton className="h-4.5 w-[90%]" /><Skeleton className="h-4.5 w-[60%]" /><Skeleton className="h-4.5 w-[80%]" /><Skeleton className="h-4.5 w-full" /><Skeleton className="h-4.5 w-[35%]" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export { DescriptionSkeleton };